const prefix = 'src/redux/users/'

export const SIGN_IN_AS = `${prefix}candidate/sign-in-as`
export const RESET_USER_ENTITY = `${prefix}entity/reset`
export const GET_USER_LIST = `${prefix}list/get`
export const GET_SINGLE_USER = `${prefix}single/get`
export const POST_USER = `${prefix}/post`
export const PUT_USER = `${prefix}single/put`
export const DELETE_USER = `${prefix}single/delete`
